
import { defineComponent } from 'vue'
import { FormatMoney } from 'format-money-js'
import { mapState } from 'vuex'

export default defineComponent({
  name: 'Statistic',
  props: ['conv'],
  computed: {
    ...mapState('authModule', ['user']),
    isMediaBuying(): boolean {
      return this.user?.data?.isMediaBuying || false
    },
  },
  data: function() {
    const moneyFormatter = new FormatMoney({
      decimals: 2,
      separator: ' ',
    })
    return {
      moneyFormatter,
    }
  },
})
